import Messages from 'global_config/error_messages';

export const buttonNames = {
  extracted: 'EXTRACTED',
  extract: 'EXTRACT',
  reject: 'REJECT'
}

export const messagePrompts = {
  successExtraction: 'Success! Sample specimen ID:',
  successPrinting: 'Success!',
  successReject: 'Request Rejected!',
  commonErrorMessage: Messages.genericError,
}